import type { ReactElement } from 'react'
import { cn } from '@/lib/cn'

export interface SkeletonProps {
  className?: string
}

/** Decorative by definition — the surrounding region owns the loading message. */
export function Skeleton({ className }: SkeletonProps): ReactElement {
  return <div aria-hidden="true" className={cn('skeleton', className)} />
}
